<!-- Horizontal Page Picker with Side Navigation -->
@if (paginationInfo.totalPages > 1) {
<div class="page-picker-section">
  @if (showHeader) {
  <div class="page-picker-header">
    <span class="picker-label text-secondary b-semibold">{{ headerTitle }}</span>
    <span class="picker-current sub text-secondary">
      {{ paginationInfo.currentPage }} de {{ paginationInfo.totalPages }}
    </span>
  </div>
  }
  <div class="page-picker-container">
    <!-- Previous Button -->
    <div class="button-container padding-x-m" (click)="onPrevClick()">
      <button class="page-picker-nav-btn prev" [disabled]="!paginationInfo.hasPrevPage">
        <img src="assets/icons/chevron-down.svg" class="chevron-icon prev-icon icon-text-secondary" alt="Anterior">
      </button>
    </div>

    <!-- Horizontal Picker Wrapper -->
    <div class="page-picker-wrapper">
      <div class="page-picker-list head">
        @for (pageNum of getPageNumbers(); track pageNum) {
        <div class="page-picker-item " [class.active]="pageNum === paginationInfo.currentPage"
          [class.adjacent]="isAdjacentPage(pageNum)" [class.h4]="pageNum === paginationInfo.currentPage"
          (click)="onPageClick(pageNum)">
          {{ pageNum.toString().padStart(2, '0') }}
        </div>
        }
      </div>
    </div>

    <!-- Next Button -->
    <div class="button-container padding-x-m" (click)="onNextClick()">
      <button class="page-picker-nav-btn next" [disabled]="!paginationInfo.hasNextPage" >
        <img src="assets/icons/chevron-down.svg" class="chevron-icon next-icon icon-text-secondary" alt="Siguiente">
      </button>
    </div>
  </div>
</div>
}